import { Component, OnInit } from "@angular/core";
import { DownloadService } from "src/app/base/services/download.service";
import { FileLoaderService } from "src/app/services/file-loader.service";

@Component({
  selector: "app-nationality-council",
  templateUrl: "./nationality-council.component.html",
  styleUrls: ["./nationality-council.component.scss"],
})
export class NationalityCouncilComponent implements OnInit {
  documents: Array<any> = [];

  constructor(
    private downloadService: DownloadService,
    private fileLoader: FileLoaderService
  ) {}

  ngOnInit(): void {
    this.loadDocs();
  }

  loadDocs() {
    this.fileLoader.getNNODocs().subscribe((docs) => {
      this.documents = docs;
    });
  }

  download(
    name: string,
    folder: string,
    year: number,
    month: string,
    id: number,
    ext: string = null,
    path: string = null
  ) {
    if (path) {
      this.downloadService.download(path, name, ext);
    } else {
      this.downloadService.download(
        `${folder}/${year}/${month}/${id}`,
        name,
        ext
      );
    }
  }
}
